export default __webpack_public_path__ + "static/media/report-pic2.13984e2e.jpg";